module.exports = __webpack_public_path__ + "4b4fedaab3f3eb5b0ae74fd60c43f0e7.png";